import { Directive, Attribute, HostListener } from '@angular/core';
import { NgModel, NgControl } from '@angular/forms';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[input-field-on-past-filter]'
})
export class LobbyCheckInInputFilterDirective {
    regExpattern: RegExp;

    constructor(@Attribute('pattern')pattern: string, private control: NgControl) {
        this.regExpattern = new RegExp(pattern);
    }

    @HostListener('input', ['$event'])
    onInputChange(event: Event) {
        const target = event.target as HTMLInputElement;
        if (target.value === '' || !target.value.replace(/\s/g, '').length) {
            this.control.control?.setValue('');
            target.defaultValue = '';
        } else {
            var test = this.regExpattern.test(target.value);
            if (test) {
                target.defaultValue = target.value;
            } else {
                this.control.control?.setValue(target.defaultValue);
            }
        }
    }
}
